/**
 * @file rest/dossiers.ts
 * Client REST dossiers Assistia (S5.4-08, mis à jour Sprint 5.14)
 *
 * Chaque méthode passe par CircuitBreaker via RestClient.
 * Fallback : SimulationProvider si backend indisponible.
 *
 * ⚠ Tous les endpoints nécessitent un JWT valide (Bearer token).
 */
// ── Implémentation ────────────────────────────────────────────────────────────
export class DossiersClientImpl {
    http;
    sim;
    constructor(http, sim) {
        this.http = http;
        this.sim = sim;
    }
    list(opts = {}) {
        const params = new URLSearchParams();
        if (opts.status)
            params.set('status', opts.status);
        if (opts.classification)
            params.set('classification', opts.classification);
        if (opts.doc_type)
            params.set('doc_type', opts.doc_type);
        if (opts.page)
            params.set('page', String(opts.page));
        if (opts.limit)
            params.set('limit', String(opts.limit));
        const qs = params.toString();
        return this.http.get(`/api/v1/dossiers/${qs ? `?${qs}` : ''}`, async () => ({ items: (this.sim?.listDossiers() ?? []), page: 1, limit: 20, total: 0 }));
    }
    getStatus(id) {
        return this.http.get(`/api/v1/dossiers/${id}/status`, async () => ({
            dossier_id: id,
            status: 'done',
            classification: 'C2',
            ocr_failed: false,
            found: true,
        }));
    }
    getResult(id) {
        return this.http.get(`/api/v1/dossiers/${id}/result`, async () => ({
            dossier_id: id,
            found: true,
            result: this.sim?.getDossier(id) ?? {},
        }));
    }
    /**
     * Récupère les événements du ledger pour un dossier.
     * Clé pour VIZ-01 : alimenter le DagCanvas avec l'historique des nœuds.
     */
    getEvents(id, opts = {}) {
        const params = new URLSearchParams();
        if (opts.limit)
            params.set('limit', String(opts.limit));
        if (opts.offset)
            params.set('offset', String(opts.offset));
        const qs = params.toString();
        return this.http.get(`/api/v1/dossiers/${id}/events${qs ? `?${qs}` : ''}`, async () => []);
    }
    listActive(page = 1, limit = 20) {
        return this.http.get(`/api/v1/dossiers/active?page=${page}&limit=${limit}`, async () => ({ items: [], page, limit, total: 0 }));
    }
    /** @deprecated */
    get(id) {
        return this.http.get(`/api/v1/dossiers/${id}`, async () => (this.sim?.getDossier(id) ?? {
            id,
            reference: 'DEMO',
            status: 'done',
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString(),
            metadata: {},
        }));
    }
    /** Upload multipart — contourne RestClient (pas de JSON body) */
    async upload(file) {
        const formData = new FormData();
        formData.append('file', file);
        try {
            const token = this.http.getToken();
            const headers = {};
            if (token)
                headers['Authorization'] = `Bearer ${token}`;
            const res = await fetch('/api/v1/dossiers/upload', {
                method: 'POST',
                headers,
                body: formData,
            });
            if (!res.ok)
                throw new Error(`HTTP ${res.status}`);
            const data = (await res.json());
            return { data, simulated: false };
        }
        catch {
            return {
                data: { dossier_id: `demo-${Date.now()}`, message: 'Upload simulé' },
                simulated: true,
            };
        }
    }
}
//# sourceMappingURL=dossiers.js.map